import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FlyoutContainer from 'components/consumer/FlyoutContainer';
import MaterialThumbnail from 'components/consumer/MaterialThumbnail';
import FabricAdditionalAttributes from 'components/consumer/FabricAdditionalAttributes';
import RatingAndReviews from 'components/consumer/RatingAndReviews';
import IconVelvet from 'components/icons/iconVelvet';
import RatioContainer from 'components/consumer/RatioContainer';
import useKeyboardControlForTabs from 'hooks/useKeyboardControlForTabs';
import useFabricReviews from 'data-hooks/useFabricReviews';
import splitArrayIntoParts from 'commons/splitArrayIntoParts';
import useScreen from 'hooks/useScreen';
import { LEATHER_PRODUCT_OPTION_ID } from 'commons/constants';
const DEFAULT_DISABLED_MATERIAL_IDS = [];
const DEFAULT_FABRIC_FAV_PROPS = {
  data: {}
};
const DEFAULT_FLASH_SALE_OPTION_IDS = [];
const DEFAULT_MATERIALS = [];
const MaterialThumbnailGroup = t0 => {
  const $ = _c(51);
  const {
    className: t1,
    disabledMaterialIds: t2,
    enableFlyout: t3,
    fabricFavProps: t4,
    flashSaleOptionIds: t5,
    flyoutAlign: t6,
    flyoutVariant,
    isEditOrder,
    isLayoutRevamp: t7,
    isModularBundleProduct: t8,
    materials: t9,
    mobileMaterialsLimit,
    moreMaterialsCount,
    onClick,
    onHover,
    onMoreMaterialsClick,
    onToggleFlyOut,
    optionId,
    selectedMaterial,
    showMoreMaterialsOnDesktop: t10,
    variant
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const disabledMaterialIds = t2 === undefined ? DEFAULT_DISABLED_MATERIAL_IDS : t2;
  const enableFlyout = t3 === undefined ? true : t3;
  const fabricFavProps = t4 === undefined ? DEFAULT_FABRIC_FAV_PROPS : t4;
  const flashSaleOptionIds = t5 === undefined ? DEFAULT_FLASH_SALE_OPTION_IDS : t5;
  const flyoutAlign = t6 === undefined ? "left" : t6;
  const isLayoutRevamp = t7 === undefined ? false : t7;
  const isModularBundleProduct = t8 === undefined ? false : t8;
  const materials = t9 === undefined ? DEFAULT_MATERIALS : t9;
  const showMoreMaterialsOnDesktop = t10 === undefined ? false : t10;
  let t11;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {};
    $[0] = t11;
  } else {
    t11 = $[0];
  }
  const [flyOutContent, setFlyOutContent] = useState(t11);
  const [isFlyOutVisible, setIsFlyOutVisible] = useState(false);
  const containerRef = useRef(null);
  const {
    isMobile
  } = useScreen();
  const thumbnailGroupRef = useRef(null);
  const t12 = mobileMaterialsLimit !== undefined;
  let t13;
  if ($[1] !== t12) {
    t13 = {
      skipHidden: t12
    };
    $[1] = t12;
    $[2] = t13;
  } else {
    t13 = $[2];
  }
  useKeyboardControlForTabs(thumbnailGroupRef, t13);
  let t14;
  bb0: {
    if (isMobile && optionId !== LEATHER_PRODUCT_OPTION_ID && !isLayoutRevamp) {
      if (materials.length < 7) {
        let t15;
        if ($[3] !== materials) {
          t15 = splitArrayIntoParts(materials, 1);
          $[3] = materials;
          $[4] = t15;
        } else {
          t15 = $[4];
        }
        t14 = t15;
        break bb0;
      }
      let t15;
      if ($[5] !== materials) {
        t15 = splitArrayIntoParts(materials, 2);
        $[5] = materials;
        $[6] = t15;
      } else {
        t15 = $[6];
      }
      t14 = t15;
      break bb0;
    }
    let t15;
    if ($[7] !== materials) {
      t15 = [materials];
      $[7] = materials;
      $[8] = t15;
    } else {
      t15 = $[8];
    }
    t14 = t15;
  }
  const newMaterials = t14;
  const {
    data: t15
  } = useFabricReviews(flyOutContent?.materialId);
  const {
    reviews,
    rating
  } = t15;
  let t16;
  if ($[9] !== disabledMaterialIds) {
    t16 = disabledMaterialIds.reduce(_temp, {});
    $[9] = disabledMaterialIds;
    $[10] = t16;
  } else {
    t16 = $[10];
  }
  const disabledMaterialsIdMap = t16;
  const {
    data: t17
  } = fabricFavProps;
  const {
    favMaterials
  } = t17;
  let t18;
  if ($[11] !== enableFlyout || $[12] !== favMaterials || $[13] !== isEditOrder || $[14] !== isModularBundleProduct || $[15] !== materials || $[16] !== onToggleFlyOut || $[17] !== rating || $[18] !== reviews) {
    t18 = (isVisible, optionValueId) => {
      const newTop = containerRef?.current?.getBoundingClientRect().top || 0;
      const selectedValue = materials?.find(material => material?.materialId === optionValueId);
      let content = {};
      const formattedAddlCost = _temp2;
      if (isVisible && selectedValue) {
        const titleInfo = <>{isEditOrder && !!selectedValue?.origAddlCost && selectedValue.origAddlCost !== selectedValue.additionalCost && <span className="line-through">{`$${selectedValue?.origAddlCost}`}</span>}{!!selectedValue?.additionalCost && <span className={classNames("PDP_flyout_AddlCost", {
            "text-red ml-1": isEditOrder
          })}>{`${formattedAddlCost(selectedValue.additionalCost)}${isModularBundleProduct ? "/piece" : ""}`}</span>}</>;
        const favDisabledNotice = selectedValue?.materialId && !!favMaterials?.[selectedValue.materialId] && selectedValue?.applicableForProduct === false ? <span className={classNames("PDP_flyout_AddlCost", {
          "text-red ml-1": true
        })}>{`This product is not available in ${selectedValue.label.trim()}`}</span> : "";
        const title = selectedValue?.label?.trim() || "";
        content = {
          materialId: optionValueId,
          top: newTop,
          subSubTitle: selectedValue.tier || selectedValue.grade || selectedValue.groupMaterialDesc || favDisabledNotice ? <><FabricAdditionalAttributes selectedItemGroupMaterial={selectedValue.groupMaterial} selectedItemGroupCleaningCode={selectedValue.cleaningCode} isPetAndKidFriendly={!!selectedValue.pet_friendly} isSustainable={!!selectedValue.sustainable_fabric} isGreenguardGold={!!selectedValue.greenguard_fabric} selectedItemTier={selectedValue.tier} selectedItemGrade={selectedValue.grade} showCleaningToolTip={false} isPantoneFabric={selectedValue.pantone_flag} materialComposition={selectedValue.groupMaterialDesc} />{favDisabledNotice}</> : null,
          subTitle: reviews?.length || selectedValue.velvet ? <>{reviews ? <RatingAndReviews rating={rating} numberOfReviews={reviews?.length} /> : null}{selectedValue.velvet ? <div className="items-center flex"><IconVelvet /><span className="text-[.8125rem] leading-[1.4375rem] font-bold text-[#af87a1] tracking-[.013rem] pl-0.5">Velvet</span></div> : null}</> : null,
          imageUrl: selectedValue?.image,
          content: selectedValue?.description,
          title,
          titleExtra: title && selectedValue?.exclude_from_sale ? "- Limited Edition" : "",
          titleInfo: selectedValue?.additionalCost ? titleInfo : 0,
          showFavIcon: !!(favMaterials && !selectedValue?.applicableForProduct === false && favMaterials[optionValueId])
        };
      }
      if (enableFlyout) {
        if (onToggleFlyOut) {
          onToggleFlyOut(content, isVisible);
        } else {
          setFlyOutContent(content);
          setIsFlyOutVisible(isVisible);
        }
      }
    };
    $[11] = enableFlyout;
    $[12] = favMaterials;
    $[13] = isEditOrder;
    $[14] = isModularBundleProduct;
    $[15] = materials;
    $[16] = onToggleFlyOut;
    $[17] = rating;
    $[18] = reviews;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  const toggleFlyOut = t18;
  let t19;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setIsFlyOutVisible(false);
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  const onClose = t19;
  const t20 = `relative w-full ${className}`;
  const t21 = !isLayoutRevamp && (variant === "PDPSelectUpholsteryUI" || variant === "PDPSelectUpholsteryUI--quickview");
  const t22 = variant === "PDPSelectUpholsteryUI--quickview";
  let t23;
  if ($[21] !== t20 || $[22] !== t21 || $[23] !== t22) {
    t23 = classNames(t20, {
      "max-[1023px]:[-ms-overflow-style:none] max-[1023px]:overflow-x-scroll max-[1023px]:overflow-y-hidden max-[1023px]:pl-5 max-[1023px]:relative max-[1023px]:[scrollbar-width:none] max-[1023px]:w-screen lg:max-[1023px]:h-[45px] max-[1023px]:md:pl-[3.333vw] [&::-webkit-scrollbar]:max-[1023px]:hidden": t21,
      "max-[1023px]:md:h-auto max-[1023px]:md:overflow-auto max-[1023px]:md:!p-0 max-[1023px]:md:w-auto": t22
    });
    $[21] = t20;
    $[22] = t21;
    $[23] = t22;
    $[24] = t23;
  } else {
    t23 = $[24];
  }
  let t24;
  if ($[25] !== flashSaleOptionIds || $[26] !== flyOutContent || $[27] !== flyoutAlign || $[28] !== flyoutVariant || $[29] !== isFlyOutVisible) {
    t24 = isFlyOutVisible ? <FlyoutContainer top={flyOutContent.top} titleInfo={flyOutContent.titleInfo} subTitle={flyOutContent.subTitle} subSubTitle={flyOutContent.subSubTitle} imageUrl={flyOutContent.imageUrl} content={flyOutContent.content} title={flyOutContent.title} titleExtra={flyOutContent.titleExtra} onClose={onClose} isOpen={isFlyOutVisible} align={flyoutAlign} showFavIcon={flyOutContent.showFavIcon} isInFlashSale={flyOutContent?.materialId ? flashSaleOptionIds.includes(flyOutContent.materialId) : false} flyoutVariant={flyoutVariant} /> : null;
    $[25] = flashSaleOptionIds;
    $[26] = flyOutContent;
    $[27] = flyoutAlign;
    $[28] = flyoutVariant;
    $[29] = isFlyOutVisible;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] !== disabledMaterialsIdMap || $[32] !== fabricFavProps || $[33] !== favMaterials || $[34] !== flashSaleOptionIds || $[35] !== isLayoutRevamp || $[36] !== mobileMaterialsLimit || $[37] !== moreMaterialsCount || $[38] !== newMaterials || $[39] !== onClick || $[40] !== onHover || $[41] !== onMoreMaterialsClick || $[42] !== selectedMaterial?.materialId || $[43] !== showMoreMaterialsOnDesktop || $[44] !== toggleFlyOut || $[45] !== variant) {
    t25 = Object.keys(newMaterials)?.map(key => <div className={isLayoutRevamp ? "grid grid-cols-6 md:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] relative z-0" : classNames("max-[1023px]:flex max-[1023px]:max-w-full lg:grid lg:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] lg:relative lg:z-0", {
      "max-[1023px]:md:grid max-[1023px]:md:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] max-[1023px]:md:relative max-[1023px]:md:z-0": variant === "PDPSelectUpholsteryUI--quickview"
    })} ref={thumbnailGroupRef} key={key}>{newMaterials[key]?.filter(_temp3)?.map((t26, index) => {
        const {
          image,
          label,
          materialId,
          upholsteryOptionId,
          description,
          color,
          applicableForProduct: t27
        } = t26;
        const applicableForProduct = t27 === undefined ? true : t27;
        const show = !(fabricFavProps?.data?.hideMaterialThumbnails && applicableForProduct);
        return <div key={materialId} className={classNames("h-full w-full", {
          "max-[1023px]:flex-shrink-0 max-[1023px]:h-[59px] max-[1023px]:min-w-[59px] max-[1023px]:w-[59px]": !isLayoutRevamp,
          "max-[1023px]:md:h-full max-[1023px]:md:min-w-[auto] max-[1023px]:md:w-full": !isLayoutRevamp && variant === "PDPSelectUpholsteryUI--quickview",
          hidden: !show,
          "max-[767px]:hidden": mobileMaterialsLimit !== undefined && index >= mobileMaterialsLimit
        })}><MaterialThumbnail color={color} description={description} fabricFavProps={fabricFavProps} image={image} isDisabled={disabledMaterialsIdMap[materialId] || !applicableForProduct} isFavMaterial={!!favMaterials?.[materialId]} isInFlashSale={flashSaleOptionIds.includes(materialId)} isSelected={materialId === selectedMaterial?.materialId} label={label} materialApplicableForProduct={applicableForProduct} materialId={materialId} onClick={onClick} onHover={onHover} toggleFlyOut={toggleFlyOut} upholsteryOptionId={upholsteryOptionId} /></div>;
      })}{!!moreMaterialsCount && !!onMoreMaterialsClick && <div className={classNames("h-full w-full max-[1023px]:flex-shrink-0 max-[1023px]:h-[59px] max-[1023px]:min-w-[59px] max-[1023px]:w-[59px] ml-1.5 md:hidden", {
        "max-[1023px]:md:h-full max-[1023px]:md:min-w-[auto] max-[1023px]:md:w-full": variant === "PDPSelectUpholsteryUI--quickview",
        "md:block": showMoreMaterialsOnDesktop
      })}><RatioContainer className="items-center flex justify-center h-full" tabIndex="0" onClick={onMoreMaterialsClick}><div className="items-center rounded-lg flex justify-center p-[5px] relative h-[calc(100%_-_4px)] hover:cursor-pointer after:[content:''] after:block after:absolute after:rounded-[inherit] before:[content:''] before:block before:absolute before:rounded-[inherit] before:z-0 before:w-full before:h-full before:[background:linear-gradient(90deg,#fdde5c_0,#f8ab5e_16.66667%,#f56a62_33.33333%,#a176c8_50%,#759beb_66.66667%,#65beb3_83.33333%,#70db96)] after:z-[1] after:w-[calc(100%_-_4px)] after:h-[calc(100%_-_4px)] after:bg-white"><span className="text-xs tracking-[.025rem] text-center z-[2] leading-[.9rem]">{`${moreMaterialsCount}+ more`}</span></div></RatioContainer></div>}{!isLayoutRevamp && <div className="flex-1 flex-shrink-0 min-w-[20px] w-5 lg:hidden" />}</div>);
    $[31] = disabledMaterialsIdMap;
    $[32] = fabricFavProps;
    $[33] = favMaterials;
    $[34] = flashSaleOptionIds;
    $[35] = isLayoutRevamp;
    $[36] = mobileMaterialsLimit;
    $[37] = moreMaterialsCount;
    $[38] = newMaterials;
    $[39] = onClick;
    $[40] = onHover;
    $[41] = onMoreMaterialsClick;
    $[42] = selectedMaterial?.materialId;
    $[43] = showMoreMaterialsOnDesktop;
    $[44] = toggleFlyOut;
    $[45] = variant;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t23 || $[48] !== t24 || $[49] !== t25) {
    t26 = <div className={t23} ref={containerRef}>{t24}{t25}</div>;
    $[47] = t23;
    $[48] = t24;
    $[49] = t25;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  return t26;
};
MaterialThumbnailGroup.propTypes = {
  disabledMaterialIds: PropTypes.arrayOf(PropTypes.number),
  enableFlyout: PropTypes.bool,
  flyoutAlign: PropTypes.oneOf(['left', 'right']),
  materials: PropTypes.arrayOf(PropTypes.shape(MaterialThumbnail.propTypes)),
  moreMaterialsCount: PropTypes.number,
  onClick: PropTypes.func,
  onMoreMaterialsClick: PropTypes.func,
  onToggleFlyOut: PropTypes.func,
  selectedMaterial: PropTypes.shape({
    description: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string,
    materialId: PropTypes.number,
    upolsteryOptionId: PropTypes.number
  }),
  fabricFavProps: PropTypes.object,
  flashSaleOptionIds: PropTypes.arrayOf(PropTypes.number),
  className: PropTypes.string,
  flyoutVariant: PropTypes.oneOf(['standard', 'protectionPlan', 'materialSwatch']),
  isEditOrder: PropTypes.bool,
  isLayoutRevamp: PropTypes.bool,
  isModularBundleProduct: PropTypes.bool,
  mobileMaterialsLimit: PropTypes.number,
  onHover: PropTypes.func,
  showMoreMaterialsOnDesktop: PropTypes.bool,
  optionId: PropTypes.number,
  variant: PropTypes.oneOf(['PDPSelectUpholsteryUI', 'PDPSelectUpholsteryUI--quickview'])
};
export default MaterialThumbnailGroup;
function _temp(acc, cur) {
  acc[cur] = true;
  return acc;
}
function _temp2(cost) {
  return cost < 0 ? `-$${cost * -1}` : `+$${cost}`;
}
function _temp3(material_0) {
  return material_0?.materialId != null;
}